import React, { useMemo } from 'react';
import TimeGrid from './TimeGrid';
import { weekDays } from '../../utils/calendarDates';

/** Week = the shared TimeGrid over the focused date's 7 local days. */
export default function WeekView({ focusedDate, ...rest }) {
  const days = useMemo(() => weekDays(focusedDate), [focusedDate]);
  return <TimeGrid days={days} {...rest} />;
}
